module.exports = "<iframe [src]=\"srcUrl\" frameborder=\"0\" style=\"width: 75vw; height: 75vh\"></iframe>"